'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useVerParam } from '~/utils/client/url-params';
import '~/stylesheets/object/project/_job_change_banner.scss';

const banners = [
  { name: 'mikeiken', alt: '未経験の方はこちら' },
  { name: 'sekokan', alt: '施工管理職の方はこちら' },
  { name: 'setsubi', alt: '設備管理職の方はこちら' },
  { name: 'shokunin', alt: '職人の方はこちら' },
];

const new_banners = [
  { image: 'other', link: 'mikeiken', name: '未経験', width: 28 },
  { image: 'sekokan', link: 'sekokan', name: '施工管理', width: 28 },
  { image: 'sekkei', link: 'setsubi', name: '設備管理', width: 22 },
  { image: 'koji', link: 'shokunin', name: '職人', width: 28 },
];

type JobChangeBannerProps = {
  isClientMobile?: boolean;
  refPrefix?: string;
};

export const JobChangeBanner = (props: JobChangeBannerProps) => {
  const [internalMobile, setInternalMobile] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const refPrefix = props.refPrefix || 'top';

  useEffect(() => {
    setIsMounted(true);
    if (typeof props.isClientMobile !== 'boolean') {
      setInternalMobile(isMobile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isClientMobile =
    typeof props.isClientMobile === 'boolean'
      ? props.isClientMobile
      : isMounted && internalMobile;

  const deviceType = isClientMobile ? 'sp' : 'pc';
  const lastText = isClientMobile ? '_sp' : '';
  const ver = useVerParam();

  return (
    <>
      <div
        className={`text-center u-font-bold ${isClientMobile ? 'u-fs14' : ''}`}
      >
        転職先のご相談
      </div>
      <div
        className={`u-flex -justify-center ${isClientMobile ? 'u-mt8 u-gap6' : 'u-mt10 u-gap16'}`}
      >
        {ver?.includes('issue_5228') && isClientMobile
          ? new_banners.map((banner) => (
              <Link
                key={banner.name}
                href={`/entry_member?ref=${refPrefix}-${banner.link}_${deviceType}`}
                className={'p-job-change-banner__item shadow'}
              >
                <Image
                  src={`/nextjs/images/characters/man_${banner.image}.webp`}
                  alt={banner.name}
                  width={banner.width}
                  height={36}
                  className="p-job-change-banner__image"
                />
                <div className="u-fs12 u-font-semibold u-color-gray u-mt1">
                  {banner.name}
                </div>
                <div className="u-fs8 u-color-gray">はこちら</div>
              </Link>
            ))
          : banners.map((banner) => (
              <Link
                key={banner.name}
                href={`/entry_member?ref=${refPrefix}-${banner.name}_${deviceType}`}
              >
                <Image
                  src={`/nextjs/images/banner/banner-${banner.name}${lastText}.webp`}
                  alt={banner.alt}
                  width={isClientMobile ? 86 : 150}
                  height={isClientMobile ? 66 : 41}
                />
              </Link>
            ))}
      </div>
    </>
  );
};
